// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"c4c655ad","680":"828d957e"}[chunkId] + ".chunk.js";
};